var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "asset=Expand, colour=NeutralDefault, htmlTag=img, assetKey=Content, state=Default"
  }, /*#__PURE__*/React.createElement("path", {
    id: "fullscreen",
    d: "M3.79361 21.0359V14.5817H6.3753V18.4543H10.2478V21.0359H3.79361ZM3.79361 9.41834V2.96411H10.2478V5.5458H6.3753V9.41834H3.79361ZM15.4112 21.0359V18.4543H19.2838V14.5817H21.8654V21.0359H15.4112ZM19.2838 9.41834V5.5458H15.4112V2.96411H21.8654V9.41834H19.2838Z",
    fill: "#2F3846"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/Expand.bce28c70ea7a6a7eedd03b2cc37016f2.svg";
export { ForwardRef as ReactComponent };